import React from 'react'
import './empty.less'
import { Link } from 'react-router-dom'
class Empty extends React.Component<any> {

  render() {
    return (
      <div className="empty">
        <img
          className="empty-img"
          src={process.env.PUBLIC_URL + '/assets/img/empty_shopping_cart.png'}
          alt="empty.png"
        />
        <p className="font-8">购物袋里什么都没有哦！</p>
        <label>
          <Link className="button" to="/store">
            去首页逛逛
          </Link>
        </label>
      </div>
    )
  }
}
export default Empty
